import React from 'react'
import { useSelector } from 'react-redux'
import {
  selectPotentialLeaguesForCloningLoading,
} from '../../reducers/potential_leagues_for_cloning'


import { GlgLoadingOverlay } from 'Shared/components'

import LeaguesBrowserList from './LeaguesBrowserList'
import LeaguesBrowserSelectedItems from './LeaguesBrowserSelectedItems'
import LeaguesBrowserFilters from './LeaguesBrowserFilters'
import { MAX_ALLOWED_LEAGUES_FOR_CLONING } from '../../constants'
import useRefetchLeagues from '../../hooks/useRefetchLeagues'
import { ViewHeader } from '../common'

const LeaguesBrowser = () => {
  const isLoading = useSelector(selectPotentialLeaguesForCloningLoading)
  useRefetchLeagues()

  return (
    <GlgLoadingOverlay
      isLoading={isLoading}
      spinnerClassName={'cls-lb-no-spinner'}
      overlayClassName={'cls-lb-transparent-overlay'}
      >
      <div className="cls-lb-main">
        <ViewHeader
          title={window.I18n.t('clone_leagues_sessions.leagues_search.clone_events_and_leagues')}
          description={window.I18n.t(
            'clone_leagues_sessions.leagues_search.select_max_leagues',
            { max_leagues: MAX_ALLOWED_LEAGUES_FOR_CLONING },
          )}
        />
        <LeaguesBrowserFilters />
        <div className="cls-lb-dual-views">
          <LeaguesBrowserList />
          <LeaguesBrowserSelectedItems />
        </div>
      </div>
    </GlgLoadingOverlay>
  )
}

export default LeaguesBrowser
